<template>
  <v-card outlined :loading="loading">
    <v-card-title>
      LISTA DE FACTUAS E HISTORIAL DE CAMBIOS
    </v-card-title>
    <v-divider/>
    <v-card-text>
      <v-row>
        <v-col cols="12" md="3">
          <v-text-field
              type="date"
              label="Desde:"
              v-model="fechaInicial"
          />
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field
              type="date"
              label="Hasta:"
              v-model="fechaFinal"
          />
        </v-col>
        <v-col cols="12" md="2">
          <v-select
              label="Tipo:"
              v-model="tipo"
              :items="tipoFacturas"
              item-value="id"
              item-text="text"
          />
        </v-col>
        <v-col cols="12" md="2">
          <v-text-field
              label="Ventanilla"
              v-model="ventanilla"
              maxlength="5"
              @keypress="patterns.onlyNumber($event)"
          />
        </v-col>
        <v-col cols="12" md="2">
          <v-btn
              color="accent"
              outlined
              title="Actualizar lista"
              class="mt-3"
              @click="listar()"
              :loading="loading"
          >
            <v-icon>mdi-update</v-icon>
            Listar
          </v-btn>
        </v-col>
      </v-row>

      <v-simple-table class="simple-table">
        <thead>
        <tr>
          <th>#</th>
          <th>Fecha</th>
          <th>Factura</th>
          <th>Periodo</th>
          <th>Cliente</th>
          <th>Total (Bs)</th>
          <th>Cajero</th>
          <th>Estado</th>
          <th>Tipo</th>
          <th>Ventanilla</th>
          <th>Opciones</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(factura, index) in facturas" :key="index" :style="rowStyle(index)">
          <td>{{ (pagination.per_page * (pagination.current_page - 1)) + (index + 1) }}</td>
          <td>{{ factura.fecha | localDateHour }}
          </td>
          <td>
            Nro. Factura: {{ factura.numero_factura }} <br>
            nfac: {{ factura.nfac }}
          </td>
          <td>{{factura.periodo}}</td>
          <td>
            Cuenta: {{ factura.cuenta }} <br>
            Ci/Nit: {{ factura.ci_nit }} <br>
            Razón social: {{ factura.razon_social }}
          </td>
          <td>
            <span :style="factura.es_conciliado ? 'text-decoration:line-through' : ''">{{factura.total }}</span>
            <span v-if="factura.es_conciliado">
              <br>
              {{factura.monto_conciliado }}
            </span>
          </td>
          <td>
            Ventanilla: {{ factura.cajero.ventanilla }} <br>
            Entidad: {{ factura.entidad }} <br>
            Sucursal: {{ factura.sucursal }}
          </td>
          <td>
            <span v-if="factura.es_anulado" class="estado-anulado">Anulado</span>
            <span v-else class="estado-vigente">Vigente</span>
          </td>
          <td>
            {{ factura.tipo }}
            <br>

            <v-chip
                v-if="factura.es_conciliado"
                color="warning"
                small
                text-color="white"
                style="margin-left: -10px"
                dark
            >
              Conciliación
            </v-chip>
          </td>
          <td class="text-center">{{ factura.cajero.ventanilla }}</td>
          <td class="text-right">
            <v-btn
                color="primary"
                small
                @click="openHistorial(factura)"
            >
              <v-icon>mdi-clipboard-list-outline</v-icon>
              Historial
            </v-btn>
          </td>
        </tr>
        </tbody>
      </v-simple-table>

      <p class="mt-5">
        <v-pagination
            v-model="pagination.current_page"
            :length="pagination.last_page"
            :total-visible="7"
            circle
            small
            @input="listar()"
        />
      </p>
    </v-card-text>

    <v-dialog v-model="showDialogHistorial" persistent max-width="700px">
      <factura-historial
          v-if="facturaSeleccionada != null"
          @close="closeHistorial()"
          :factura="facturaSeleccionada"
      />
    </v-dialog>
  </v-card>
</template>

<script lang="ts">
import {Component, Vue} from "vue-property-decorator";
import {DateTime} from "luxon";
import {Pattern} from "@/addons/Pattern";
import {recaudacionStore} from "@/store/recaudacionStore";
import {RecaudacionService} from "@/services/RecaudacionService";
import FacturaHistorial from "@/views/facturas/FacturaHistorial.vue";

@Component({
  name: "FacturaIndex",
  components: {FacturaHistorial}
})
export default class FacturaIndex extends Vue {
  private patterns = Pattern;
  private recaudacionStore = recaudacionStore();
  private recaudacionService = RecaudacionService.getInstance();

  private fechaInicial = DateTime.now().toFormat("yyyy-MM-dd");
  private fechaFinal = DateTime.now().toFormat("yyyy-MM-dd");
  private ventanilla = null;

  private facturaSeleccionada: any = null;

  private tipoFacturas = [
    {id: '%', text: 'Todos'},
    {id: 'ConsumoAgua', text: 'Consumo de agua'},
    {id: 'OtroServicio', text: 'Otros ingresos'},
  ];
  private tipo = '%';

  get facturas(): any[] {
    return this.recaudacionStore.facturas;
  }

  get loading(): boolean {
    return this.recaudacionStore.loading;
  }

  get pagination(): any {
    return this.recaudacionStore.pagination;
  }

  get showDialogHistorial(): boolean {
    return this.recaudacionStore.showDialogHistorial;
  }

  mounted() {
    this.listar();
  }

  rowStyle(index: number) {
    if (index % 2 === 0) return {};
    return { backgroundColor: this.$vuetify.theme.dark ? 'rgba(255,255,255,0.05)' : '#FAFAFA' };
  }

  listar() {
    const data = {
      fechaInicial: this.fechaInicial,
      fechaFinal: this.fechaFinal,
      tipoFactura: this.tipo,
      ventanilla: this.ventanilla,
      page: this.pagination.current_page
    };
    this.recaudacionService.index(data);
  }

  openHistorial(factura:any) {
    this.facturaSeleccionada = factura;
    this.recaudacionStore.showDialogHistorial = true;

    this.recaudacionService.getHistorial(factura.id);
  }

  closeHistorial() {
    this.recaudacionStore.showDialogHistorial = false;
  }
}
</script>

<style scoped>
.simple-table {
  border: 1px solid #DDDDDD;
}

.estado-anulado { color: #C62828; }
.estado-vigente { color: #2E7D32; }

.theme--dark.simple-table {
  border: 1px solid rgba(255, 255, 255, 0.12);
}

.theme--dark .estado-anulado { color: #EF9A9A; }
.theme--dark .estado-vigente { color: #A5D6A7; }
</style>